import { red, grey, blueGrey } from "@material-ui/core/colors"
import createBreakpoints from "@material-ui/core/styles/createBreakpoints"

import { createMuiTheme } from "@material-ui/core/styles"

const breakpoints = createBreakpoints({})

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#D5212A",
    },
    secondary: {
      main: "#D5212A",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#f7f7f7",
    },
  },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 960,
  //     lg: 1550,
  //     xl: 1920,
  //   },
  // },
  typography: {
    fontFamily: [
      "Cabin",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ],
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: {
          WebkitFontSmoothing: "auto",
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: 0,
      },
    },
    MuiTypography: {
      h1: {
        fontSize: "2.5rem",
        fontWeight: 700,
        marginBottom: "1rem",
        "&>em": {
          color: "#D5212A",
          fontStyle: "normal",
        },
      },
      h2: {
        fontSize: "1.375rem",
        fontWeight: 500,
        marginBottom: "1rem",
        color: "#D5212A",
        "&>em": {
          fontWeight: 700,
          marginRight: "1rem",
          color: "#000",
          fontStyle: "normal",
          whiteSpace: "nowrap",
        },
      },
      h3: {
        fontSize: "1.2rem",
        fontWeight: 700,
        color: "#D5212A",
        marginBottom: "1rem",
      },
      h4: {
        fontSize: "1.125rem",
        fontWeight: 700,
      },
      body1: {
        fontSize: "1.125rem",
      },
      body2: {
        fontSize: "1rem",
        color: "#606060",
      },
      subtitle1: {
        fontSize: "1rem",
        fontWeight: 500,
        // marginBottom: "1rem",
      },
      subtitle2: {
        fontSize: "0.75rem",
        fontWeight: 500,
        textTransform: "uppercase",
        color: "#A09387",
        letterSpacing: "1px",
      },
    },
    MuiAvatar: {
      root: {
        width: 50,
        height: 50,
      },
    },
    MuiTab: {
      root: {
        minHeight: "initial",
        backgroundColor: grey[300],
        borderRadius: 6,
        [breakpoints.up("xs")]: {
          minWidth: 100,
        },
        "&$selected": {
          backgroundColor: red[500],
          color: "#fff",
        },
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: "initial",
      },
    },
    // MuiOutlinedInput: {
    //   input: {
    //     padding: "10px 14px",
    //   },
    // },
    MuiInputBase: {
      root: {
        backgroundColor: "#f7f7f7",
      },
    },
    MuiAutocomplete: {
      tag: {
        color: "#fff",
        backgroundColor: "#D5212A",
      },
    },
  },
})

export default theme
